import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import router from '@/router';
//import store from '@/store';
import { getCookie } from '@/utils/cookies';
import { urlInfo } from '@/utils/url-parse';
import { getURL } from '@/service/http';
/*
кастомный стор для грида.
props:
    key,
    args = {
         db_schema_name,
         db_view_name,
         token,
         storeName - имя стора , где лежит мета,
         stateMetaName - название массива мета даты
    },
    api
 */
export const gridCardStore = meta => {
    // const url = `http://${process.env.VUE_APP_HOST}:${process.env.VUE_APP_PORT}/api/`;
    // const url = `${window.location.origin}/api/`;
    const url = getURL('api/');
    const aspStore = AspNetData.createStore({
        loadMethod: 'POST',
        key: meta.keyExpr,
        loadUrl: url,
        requireTotalCount: true,
        onLoaded: result => {
            if (!Array.isArray(result)) {
                router.push({
                    name: 'loginForm',
                });
            }
        },
        onBeforeSend: (e, ajax) => {
            const data = ajax.data;
            ajax.data.args = JSON.stringify({
                ...data,
                api: meta.loadUrl,
                token: getCookie('token'),
                meta: meta.columns,
                appId: urlInfo().appId,
                ...(meta.meta_args && { meta_args: meta.meta_args }),
            });
            ajax.data.api = meta.loadUrl;
        },
    });
    return aspStore;
};
